import '@/components/EpRadioButton/EpRadioButton.scss';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import clsx from 'clsx';
import { InputHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';
interface EpRadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
  radioId?: string;
  radioValue: string;
  radioName: string;
  radioLabel: string;
  required?: boolean;
  translations?: unknown;
  radioWithError?: boolean;
}

export const EpRadioButton = ({
  radioId,
  radioValue,
  radioName,
  radioLabel,
  required = true,
  translations,
  errorMessage = '* Required Fied',
  radioWithError = false,
  ...props
}: EpRadioButtonProps) => {
  const { register, setValue } = useFormContext();
  const radioCustomId = radioId
    ? radioId
    : `EpRadio__${radioName}--${radioLabel}`;

  // return(
  //   <Controller
  //     name={`${radioName}.inputValue`}
  //     control={control}
  //     rules={{ required: { value: required, message: errorMessage } }}
  //     render={({ field }) => (
  //       <EpRadio radioName={radioName} radioLabel={radioLabel} radioValue={radioValue} {...field}/>
  //     )}
  //   />
  // );
  return (
    <div className="ep-radio-button">
      <input
        {...register(`${radioName}.inputValue` as const, {
          required: {
            value: required,
            message: t(translations, errorMessage),
          },
          // onChange: () => setValue(`${radioName}.inputLabel`, radioLabel)
        })}
        className={clsx(
          'form-check-input ep-radio-button__input',
          radioWithError && 'ep-radio-button--with-error'
        )}
        type="radio"
        value={radioValue}
        id={radioCustomId}
        style={{ marginRight: '8px' }}
        onClick={() => setValue(`${radioName}.inputLabel`, radioLabel)}
        {...props}
      />
      <label
        htmlFor={radioCustomId}
        className={clsx(
          'form-check-label ep-radio-button__label',
          radioWithError && 'ep-radio-button__label--with-error'
        )}
      >
        <span
          className={clsx(
            'ep-radio-button__label-text',
            radioWithError && 'ep-radio-button__label--with-error'
          )}
        >
          {radioLabel}
        </span>
      </label>
    </div>
  );
};
